export const ACTION_START = 'ACTION_START'

export const ACTION_CONFIRM_PIN = 'ACTION_CONFIRM_PIN'
